module.exports = __webpack_public_path__ + "img/icon01.eee3f686.png";